"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function Loader(_a) {
    var label = _a.label;
    return (react_1.default.createElement(StyledLoader, null,
        react_1.default.createElement(core_ui_1.Padding, { size: 12 },
            react_1.default.createElement(core_ui_1.CircleSpinnerInline, { label: label }))));
}
exports.Loader = Loader;
var StyledLoader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: calc(50% - 20px);\n  border-radius: 5px;\n  overflow: hidden;\n\n  :before {\n    position: absolute;\n    content: '';\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: ", ";\n    z-index: -1;\n  }\n"], ["\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: calc(50% - 20px);\n  border-radius: 5px;\n  overflow: hidden;\n\n  :before {\n    position: absolute;\n    content: '';\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: ", ";\n    z-index: -1;\n  }\n"])), core_ui_1.colors.steel[100]);
var templateObject_1;
